import { Button } from '@/components/ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import heroImage from '@assets/generated_images/Aerial_fiber_installation_hero_2ad6a4bc.png';

export default function HeroSection() {
  const handleGetStarted = () => {
    console.log('Get Started clicked');
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      // Get the element's position relative to the document
      const rect = contactElement.getBoundingClientRect();
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = rect.top + currentScroll;
      const headerHeight = 100; // Fine-tuned offset for optimal positioning
      const targetPosition = elementTop - headerHeight;
      
      console.log('Element top:', elementTop);
      console.log('Target scroll position:', targetPosition);
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleLearnMore = () => {
    console.log('Learn More clicked');
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      // Get the element's position relative to the document
      const rect = contactElement.getBoundingClientRect();
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = rect.top + currentScroll;
      const headerHeight = 100; // Fine-tuned offset for optimal positioning
      const targetPosition = elementTop - headerHeight;
      
      console.log('Element top:', elementTop);
      console.log('Target scroll position:', targetPosition);
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    } else {
      console.log('Contact element not found!');
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${heroImage})` 
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Connecting America Through
            <span className="block text-chart-2">Fiber Infrastructure</span>
          </h1>
          
          <p className="text-xl sm:text-2xl text-gray-200 mb-8 leading-relaxed max-w-3xl mx-auto">
            Professional telecom infrastructure services including engineering, construction, 
            fulfillment, maintenance, and project management for fiber optic networks.
          </p>

          {/* Key Benefits */}
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <div className="flex items-center space-x-2 text-white">
              <CheckCircle className="h-5 w-5 text-chart-2" />
              <span className="font-medium">Expert Engineering</span>
            </div>
            <div className="flex items-center space-x-2 text-white">
              <CheckCircle className="h-5 w-5 text-chart-2" />
              <span className="font-medium">Turnkey Construction</span>
            </div>
            <div className="flex items-center space-x-2 text-white">
              <CheckCircle className="h-5 w-5 text-chart-2" />
              <span className="font-medium">24/7 Maintenance</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-chart-2 hover:bg-chart-2/90 text-white px-8 py-3 text-lg font-semibold"
              onClick={handleGetStarted}
              data-testid="button-get-started"
            >
              Get Started
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-white text-white hover:bg-white hover:text-foreground px-8 py-3 text-lg font-semibold bg-white/10 backdrop-blur"
              onClick={handleLearnMore}
              data-testid="button-learn-more"
            >
              Learn More
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-12 pt-8 border-t border-white/20">
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2" data-testid="stat-projects">500+</div>
              <div className="text-gray-200">Projects Completed</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2" data-testid="stat-miles">10,000+</div>
              <div className="text-gray-200">Miles of Fiber Installed</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2" data-testid="stat-years">15+</div>
              <div className="text-gray-200">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}